import { isString } from 'lodash';

export default function trim(value) {
  return isString(value) ? value.trim() : value;
}
